if (!customElements.get('ffb-product-nav')) {
  customElements.define('ffb-product-nav', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.bar = this.querySelector('.ffb-pnav-bar');
      this.marker = this.querySelector('.ffb-pnav-marker');
      this.links = [...this.querySelectorAll('.ffb-pnav-link')];
      this.entries = [];
      this.resolveTargets();
      this.links.forEach(link => link.addEventListener('click', event => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const entry = this.entries.find(item => item.link === link);
        if (!entry) return;
        event.preventDefault();
        const target = entry.target;
        // Support an explicitly targeted accordion without changing other content.
        let parent = target;
        while (parent) {
          if (parent.tagName === 'DETAILS') parent.open = true;
          parent = parent.parentElement;
        }
        const hadTabindex = target.hasAttribute('tabindex');
        if (!hadTabindex) {
          target.setAttribute('tabindex','-1');
          target.addEventListener('blur', () => target.removeAttribute('tabindex'), {once:true});
        }
        target.focus({preventScroll:true});
        const top = scrollY + target.getBoundingClientRect().top - this.topOffset() - this.bar.getBoundingClientRect().height - 28;
        window.scrollTo({top:Math.max(0,top), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }, options));
      document.addEventListener('scroll', () => this.schedule(), {...options,passive:true});
      window.addEventListener('resize', () => this.schedule(), options);
      document.addEventListener('toggle', () => this.schedule(), {...options,capture:true});
      document.addEventListener('load', () => this.schedule(), {...options,capture:true});
      document.addEventListener('shopify:section:load', () => this.resolveTargets(), options);
      document.addEventListener('shopify:section:unload', () => this.scheduleResolve(), options);
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.scheduleResolve();
      });
      this.observer.observe(document.querySelector('main') || document.body,{childList:true,subtree:true});
      this.header = document.querySelector('ffb-header');
      if (this.header) {
        this.headerObserver = new MutationObserver(() => this.schedule());
        this.headerObserver.observe(this.header,{attributes:true,subtree:true,attributeFilter:['data-menu-open','open']});
      }
      this.overlayObserver = new MutationObserver(() => this.schedule());
      this.overlayObserver.observe(document.documentElement,{attributes:true,attributeFilter:['class']});
      this.schedule();
    }
    scheduleResolve() {
      clearTimeout(this.resolveTimer);
      this.resolveTimer = setTimeout(() => this.resolveTargets(),100);
    }
    resolveTargets() {
      this.entries = [];
      this.links.forEach((link,index) => {
        let target = null;
        // Selector order is preference order, not document order.
        for (const selector of link.dataset.target.split(',')) {
          try { target = document.querySelector(selector.trim()); } catch (_) { target = null; }
          if (target && !this.contains(target)) break;
          target = null;
        }
        link.hidden = !target;
        if (!target) return;
        if (!target.id) target.id = `ffb-pnav-target-${this.closest('[id]')?.id || 'product'}-${index}`;
        link.setAttribute('href',`#${target.id}`);
        this.entries.push({link,target});
      });
      this.schedule();
    }
    topOffset() {
      const header = document.querySelector('.header-section');
      let top = 0;
      if (header && header.getClientRects().length) {
        const rect = header.getBoundingClientRect();
        // Only reserve the portion of the page header still visible at the top.
        if (rect.top <= 1 && rect.bottom > 0) top = rect.bottom;
      }
      return top + (Number(this.dataset.extraOffset) || 0);
    }
    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
    }
    update() {
      if (!this.isConnected) return;
      const top = this.topOffset();
      this.bar.style.setProperty('--ffb-pnav-top',`${top}px`);
      const menuOpen = this.header?.hasAttribute('data-menu-open') || this.header?.querySelector('details[open]');
      const overlay = /(?:quick-search-open|side-cart-open|sidecart-open|site-panel-open)/.test(document.documentElement.className);
      this.bar.hidden = !this.entries.length;
      if (this.bar.hidden) {
        this.marker.style.height = '0px';
        this.bar.classList.remove('is-sticky');
        return;
      }
      const sticky = this.marker.getBoundingClientRect().top <= top;
      // Reserve the same height when the bar leaves normal flow.
      const height = this.bar.getBoundingClientRect().height;
      this.marker.style.height = sticky ? `${height}px` : '0px';
      this.bar.classList.toggle('is-sticky', sticky);
      this.bar.style.visibility = menuOpen || overlay ? 'hidden' : '';
      this.bar.inert = !!menuOpen || overlay;
      const cutoff = top + this.bar.getBoundingClientRect().height + 28;
      const visible = this.entries.filter(item => item.target.isConnected && item.target.getClientRects().length)
        .map(item => ({...item,top:item.target.getBoundingClientRect().top})).sort((a,b) => a.top-b.top);
      let active = visible[0];
      for (const entry of visible) if (entry.top <= cutoff) active = entry;
      this.entries.forEach(entry => {
        if (entry.link === active?.link) entry.link.setAttribute('aria-current','location');
        else entry.link.removeAttribute('aria-current');
      });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
      this.headerObserver?.disconnect();
      this.overlayObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
      clearTimeout(this.resolveTimer);
    }
  });
}
